import mainVideo from './js/widgets/mainVideo.js';
import eventCards from './js/widgets/eventCards.js';
import inducteesTitle from './js/widgets/inducteesTitle.js';
import inducteesCards from './js/widgets/inducteesCards.js';
import seoWidget from './js/widgets/seoWidget.js';
import customVideoWidget from './js/widgets/customVideoWidget.js';
import sponsors from './js/widgets/sponsors.js';
import customFeatureLineUp from './js/featureLineUp.js';

import './js/localjs.js';

$(document).ready(function () {
  if (window.location.pathname === '/') {
    mainVideo();
    eventCards();
    inducteesTitle();
    inducteesCards();
    seoWidget();
    customVideoWidget('videoOne', videoOneOpts);
    customVideoWidget('videoTwo', videoTwoOpts);
    customVideoWidget('videoThree', videoThreeOpts);
    sponsors();
  } else {
    customFeatureLineUp();
  }
});
